import React from 'react'

import { addListener, removeListener } from 'component-library/__helpers/global-dom-events'

import {
    StyledHeaderContainer,
    StyledAd,
    StyledNavigation,
} from 'component-library/content/TheWestStickySiteHeader/TheWestStickySiteHeader.styled'
import { withRouter, RouteComponentProps } from 'react-router'
import { DimensionProps, withDimensions } from 'component-library/__helpers/with-dimensions'

export interface Props {
    headerAd?: (rendered?: () => void) => JSX.Element | undefined

    header: JSX.Element
    navigation: JSX.Element
}

type InternalProps = Props & DimensionProps & RouteComponentProps<any>

export interface State {
    isHidden: boolean
    isTop: boolean
    scrollUp: boolean
}

export class InternalTheWestStickySiteHeader extends React.Component<InternalProps, State> {
    private currentScrollPos = 0

    constructor(props: InternalProps) {
        super(props)

        this.state = {
            isHidden: false,
            isTop: true,
            scrollUp: false,
        }
    }

    /**
     * Checks viewport scroll level.
     * If user has scrolled over scrollTarget in px it sets the component to hidden and it scrolls off the page.
     * Upon scrolling up, it checks if the component is hidden and brings it back into view
     */
    handleScroll = () => {
        const scrollTarget = 500 // tweak this value on what feels better from a UX point of view
        const prevScrollPos = this.currentScrollPos
        this.currentScrollPos = window.pageYOffset
        const currentScrollPos = this.currentScrollPos
        const isHidden = this.state.isHidden
        const shouldHide = currentScrollPos >= scrollTarget
        const userScrollUp = currentScrollPos <= prevScrollPos
        const userScrollDistance = Math.abs(currentScrollPos - prevScrollPos)
        /**
         * Dont want the component appearing after small scroll up, so calculate the distance
         * user has scrolled and see if it has met a certain distance threshold
         */
        const scrollUpThresholdMet = userScrollDistance >= 200 ? true : false

        if (this.currentScrollPos === 0) {
            this.setState({
                isHidden: false,
                scrollUp: false,
                isTop: true,
            })
        } else if (userScrollUp && scrollUpThresholdMet && isHidden) {
            this.setState({
                isHidden: false,
                scrollUp: true,
                isTop: false,
            })
        } else if (shouldHide && !userScrollUp && !isHidden) {
            this.setState({
                isHidden: true,
                scrollUp: false,
                isTop: false,
            })
        }
    }

    componentDidMount() {
        addListener('scroll', this.handleScroll)
    }

    componentWillUnmount() {
        removeListener('scroll', this.handleScroll)
    }

    render() {
        return (
            <React.Fragment>
                {this.props.headerAd && (
                    <StyledAd
                        className="headerAdvertisement"
                        ref={this.props.innerRef}
                        isHidden={this.state.isHidden}
                        scrollUp={this.state.scrollUp}
                        isTop={this.state.isTop}
                        height={this.props.height}
                    >
                        {this.props.headerAd(() => this.props.triggerMeasure())}
                    </StyledAd>
                )}
                <StyledNavigation
                    className="header-navigation"
                    scrollUp={this.state.scrollUp}
                    isHidden={this.state.isHidden}
                    isTop={this.state.isTop}
                    height={this.props.height}
                >
                    {this.props.navigation}
                </StyledNavigation>
                <StyledHeaderContainer className="masthead">
                    {this.props.header}
                </StyledHeaderContainer>
            </React.Fragment>
        )
    }
}

export const TheWestStickySiteHeader = withRouter(
    withDimensions<Props & RouteComponentProps<any>>(InternalTheWestStickySiteHeader)
)
TheWestStickySiteHeader.displayName = 'TheWestStickySiteHeader'
